export const iconFontAwesomeScienceFlaskVial = (
	<i className="fa-solid fa-flask-vial"></i>
);
